import React from 'react'
import { CardSwiper } from '../CardSwiper'
import type { FeedItem } from '../../Api'
import { FeedCard } from './FeedCard'

type FeedCardListProps = {
  feedItems: FeedItem[]
  section?: string
  cardSize?: 'normal' | 'small'
  theme?: 'light' | 'dark'
}

export const FeedCardList: React.FC<React.PropsWithChildren<FeedCardListProps>> = ({
  feedItems,
  section,
  cardSize = 'normal',
  theme = 'light'
}) => {
  return (
    <CardSwiper
      items={feedItems.map((item) => (
        <FeedCard size={cardSize} feedItem={item} section={section} theme={theme} />
      ))}
      cardSize={cardSize}
    />
  )
}